import { render, staticRenderFns } from "./jList.vue?vue&type=template&id=4ab6df9f&scoped=true&"
import script from "./jList.vue?vue&type=script&lang=js&"
export * from "./jList.vue?vue&type=script&lang=js&"
import style0 from "./jList.vue?vue&type=style&index=0&id=4ab6df9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6df9f",
  null
  
)

export default component.exports